<template>
  <div id="illegalReport">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>数据中心</el-breadcrumb-item>
          <el-breadcrumb-item>{{title}}</el-breadcrumb-item>
          <el-breadcrumb-item>违章记录查询</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-form :inline="true"
             label-width="80px">
      <el-row>
        <el-col :span="24">
          <el-form-item label="客户::">
            <el-select v-model="pageSearch.fCustID"
                       @change="changeCust"
                       clearable
                       filterable
                       placeholder="请选择客户"
                       style="width:200px;">
              <el-option v-for="item in cust_list"
                         :key="item.fCustID"
                         :label="item.unionName"
                         :value="item.fCustID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="院系::">
            <el-input placeholder="请输入院系名称"
                      v-model="pageSearch.fUnitName"
                      class="search"></el-input>
          </el-form-item>
          <el-form-item label="开始时间::">
            <el-date-picker v-model="startTime"
                            style="width:200px"
                            type="datetime"
                            :clearable="false"
                            placeholder="选择违章开始时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间::">
            <el-date-picker v-model="endTime"
                            style="width:200px"
                            :clearable="false"
                            type="datetime"
                            placeholder="选择违章结束时间">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="车辆性质::">
            <el-select v-model="pageSearch.fCarMode"
                       clearable
                       filterable
                       placeholder="请选择车辆性质"
                       style="width:200px;">
              <el-option v-for="item in cardModeList"
                         :key="item.value"
                         :label="item.text"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="违章类型::">
            <el-select v-model="pageSearch.fBRType"
                       clearable
                       filterable
                       placeholder="请选择违章类型"
                       style="width:200px;">
              <el-option v-for="item in BRTypeList"
                         :key="item.value"
                         :label="item.text"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="车辆类型::">
            <el-select v-model="pageSearch.fCarType"
                       clearable
                       filterable
                       placeholder="请选择车辆类型"
                       style="width:200px;">
              <el-option v-for="item in carTypeList"
                         :key="item.value"
                         :label="item.text"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="关键字::">
            <el-input placeholder="请输入车主姓名、电话、车牌"
                      v-model="pageSearch.searchKeyWord"
                      class="search"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-button type="primary"
                       size="small"
                       icon="el-icon-search"
                       @click="page_list">查询</el-button>
            <el-button type="success"
                       size="small"
                       icon="el-icon-share"
                       :loading="export_loading"
                       v-if="is_export"
                       @click="exportData">{{export_msg}}</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row>
      <el-col :span="24"
              style="height: 5px"></el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="pageData"
                  :height="tableHeight"
                  highlight-current-row
                  v-loading="loading"
                  border
                  stripe
                  style="width: 100%">
          <el-table-column width="50"
                           type="index"
                           :index="indexMethod"
                           label="序号">
          </el-table-column>
          <el-table-column prop="fCustNo"
                           width="80"
                           label="客户编号">
          </el-table-column>
          <el-table-column prop="fInTime"
                           width="160"
                           label="进场时间">
          </el-table-column>
          <el-table-column prop="fPlateCode"
                           width="100"
                           label="车牌号码">
          </el-table-column>
          <el-table-column prop="fParkNo"
                           label="场库编号">
          </el-table-column>
          <el-table-column prop="fParkName"
                           label="场库名称">
          </el-table-column>
          <el-table-column prop="fCardCustCreNo"
                           label="工号">
          </el-table-column>
          <el-table-column prop="fCardCustName"
                           label="车主姓名">
          </el-table-column>
          <el-table-column prop="fCardCustPhone"
                           label="车主电话">
          </el-table-column>
          <el-table-column prop="fBRType"
                           label="违章类型">
          </el-table-column>
          <el-table-column prop="fBRTime"
                           width="160"
                           label="违章时间">
          </el-table-column>
          <el-table-column prop="fBRAddr"
                           label="违章地点">
          </el-table-column>
          <el-table-column prop="fFactTime"
                           label="处理时间">
          </el-table-column>
          <el-table-column prop="fFactUsrName"
                           label="处理人">
          </el-table-column>
          <el-table-column prop="fStatusName"
                           label="状态">
          </el-table-column>
          <el-table-column prop="fRemark"
                           label="备注">
          </el-table-column>
          <el-table-column label="操作"
                           align="center"
                           fixed="right"
                           width="100">
            <template slot-scope="scope">
              <el-button size="mini"
                         type="success"
                         @click="handleInfo(scope.$index, scope.row)">查看</el-button>
              <!-- <el-button size="mini"
                         type="primary"
                         v-if="scope.row.fStatus=='0'"
                         @click="handle(scope.$index, scope.row)">处理</el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination @current-change="handleCurrentChange"
                         @size-change="handleSizeChange"
                         :current-page="pageSearch.pageIndex"
                         :page-size="pageSearch.pageSize"
                         :page-sizes="[10, 20, 50, 100]"
                         background
                         layout="total,sizes, prev, pager, next, jumper"
                         :total="pageCount"
                         v-if="pageCount>0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <el-dialog :title="dialogTitle"
               width="55%"
               top="7vh"
               v-loading="true"
               :visible.sync="dialogVisible"
               v-dialogDrag>
      <el-form label-width="110px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="客户编号">
              <el-input v-model="form.fCustNo"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="客户名称">
              <el-input v-model="form.fCustName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="进出记录ID">
              <el-input v-model="form.fBusID"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="场库编号">
              <el-input v-model="form.fParkNo"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="场库名称">
              <el-input v-model="form.fParkName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="进场时间">
              <el-input v-model="form.fInTime"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="工号">
              <el-input v-model="form.fCardCustCreNo"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="车主姓名">
              <el-input v-model="form.fCardCustName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="车主电话">
              <el-input v-model="form.fCardCustPhone"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="违章时间">
              <el-input v-model="form.fBRTime"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="车牌号码">
              <el-input v-model="form.fPlateCode"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="违章类型">
              <el-input v-model="form.fBRType"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="违章地址">
              <el-input v-model="form.fBRAddr"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="处理人">
              <el-input v-model="form.fFactUsrName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="处理时间">
              <el-input v-model="form.fFactTime"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="处理方式">
              <el-input v-model="form.fFactType"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注">
              <el-input v-model="form.fRemark"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="违章图片"
                          class="break_rule_img">
              <el-image :src="form.url"
                        style="width: 300px; height: 300px"
                        :preview-src-list="form.srcList">
              </el-image>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>

        </el-row>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <span :class="(form.fStatus=='10'?'success':'danger')"
              style="font-size:20px;font-weight:bold;float:left;padding-left:100px">
          {{form.fStatusName}}
        </span>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { report as api } from '../../api/report'
import * as park from '../../api/park'
import * as user from '../../api/user'
const delay = (function () {
  let timer = 0
  return function (callback, ms) {
    clearTimeout(timer)
    timer = setTimeout(callback, ms)
  }
})()
export default {
  data () {
    return {
      title: '定制报表',
      dialogTitle: '',
      dialogVisible: false,
      form: {},
      is_export: false,
      tableHeight: 0,
      pageCount: 0,
      loading: false,
      export_loading: false,
      export_msg: '导出',
      cardModeList: [],
      BRTypeList: [],
      carTypeList: [{ value: '[1,2]', text: '校内车' }, { value: '3', text: '协作车' }, { value: '4', text: '报备车' }],
      pageData: [],
      total: {},
      cust_list: [],
      startTime: '',
      endTime: '',
      pageSearch: {
        pageIndex: 1,
        pageSize: 20,
        fCustID: '',
        fStartTime: '',
        fEndTime: '',
        searchKeyWord: '',
        fCarType: '',
        fUnitName: '',
        fCarMode: '',
        fBRType: '',
        isExport: 1

      }

    }
  },
  methods: {
    // 搜索词搜索
    wordSearch () {
      delay(() => {
        this.page_list()
      }, 1000)
    },
    page_list (index) {
      if (index && index >= 1) {
        this.pageSearch.pageIndex = index
      } else {
        this.pageSearch.pageIndex = 1
      }
      this.loading = true
      this.pageSearch.fStartTime = this.$dateFormat(this.startTime, 'yyyy-MM-dd hh:mm:ss')
      this.pageSearch.fEndTime = this.$dateFormat(this.endTime, 'yyyy-MM-dd hh:mm:ss')
      this.pageSearch.isExport = 0
      api.illegalCarList(this.pageSearch).then(res => {
        this.loading = false
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.pageData = data.Data.data || []
            this.pageCount = data.Data.count
          } else {
            this.$message.error('提示：查询违章信息异常')
          }
        }
      })
    },
    indexMethod (index) {
      return this.pageSearch.pageSize * (this.pageSearch.pageIndex - 1) + index + 1
    },
    changeCust (val) {
      if (val) {
        this.userNoDisabled = false
      } else {
        this.pageSearch.searchKeyWord = ''
        this.userNoDisabled = true
      }
    },
    init () {
      var today = new Date()
      this.startTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0)
      this.endTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59)
      park.getCustByGroup({ fCustTypeID: 0 }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.cust_list = data.Data
            // if (this.cust_list && this.cust_list.length > 0) {
            //   this.pageSearch.fCustID = this.cust_list[0].fCustID
            //   this.loadPark(this.pageSearch.fCustID)
            // }
          } else {
            this.$message.error('提示：加载客户列表失败')
          }
        }
      })
      api.sj_carModel().then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.cardModeList = data.Data.CarTypeList || []
            this.BRTypeList = data.Data.BRTypeList || []
            if (this.cardModeList.length > 0) {
              this.cardModeList.splice(0, 1)
            }
          } else {
            this.$message.error('提示：加载车辆性质列表失败')
          }
        }
      })
      user.getCurrentUserPers({ perTypeId: 69500 }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            if (data.Data) {
              this.is_export = data.Data.data.is_export
            }
          } else {
            this.$message.error('提示：加载当前用户权限信息失败')
          }
        }
      })
    },
    handleInfo (index, row) {
      this.form = row
      var urls = row.fPicUrlList.split(/\n/g)
      if (urls.length > 0) {
        this.form.url = urls[0]
        this.form.srcList = urls
      } else {
        this.form.url = ''
        this.form.srcList = []
      }
      this.dialogTitle = '【' + row.fCustNo + '】' + row.fParkName + '-' + row.fPlateCode + '-违章记录'
      this.dialogVisible = true
    },
    handle (index, row) {
      this.$confirm('请确认是否处理[车牌:' + row.fPlateCode + ' 违章时间:' + row.fBRTime + '  违章类型:' + row.fBRType + ']?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api.illegalCarHandle({ fBigRowID: row.fBigRowID }).then(res => {
          console.log(res)
          if (res && res.data) {
            var data = res.data
            if (data.IsOk) {
              this.$message({
                type: 'success',
                message: data.Msg
              })
              this.page_list()
            } else {
              this.$message.error('提示：' + data.Msg)
            }
          }
        })
      }).catch(() => { })
    },
    exportData () {
      if ((this.pageSearch.fCustID || '').trim().length <= 0) {
        this.$message.error('提示：请先选择客户')
        return false
      }
      this.pageSearch.fStartTime = this.$dateFormat(this.startTime, 'yyyy-MM-dd hh:mm:ss')
      this.pageSearch.fEndTime = this.$dateFormat(this.endTime, 'yyyy-MM-dd hh:mm:ss')
      this.export_loading = true
      this.export_msg = '导出中……'
      var fileName = '所有客户'
      if ((this.pageSearch.fCustID || '').trim().length > 0) {
        var custArr = (this.cust_list || []).filter((item) => {
          return item.fCustID === this.pageSearch.fCustID
        })
        fileName = custArr.length > 0 ? custArr[0].unionName : ''
      }
      this.pageSearch.isExport = 1
      api.illegalCarList(this.pageSearch).then(res => {
        this.export_loading = false
        this.export_msg = '导出'
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            if (data.Data) {
              this.fileDownload(data.Data, fileName + '_违章查询报表.xls')
            }
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    handleSizeChange (val) {
      this.pageSearch.pageSize = val
      this.page_list(this.pageSearch.pageIndex)
    },
    handleCurrentChange (val) {
      this.page_list(val)
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 250
      obj.tableHeight = clientHeight
    }
  },
  created () {
  },
  mounted () {
    window.onresize = () => {
      this.setTableHeight(this)
    }
    this.init()
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>
<style>
/* dialog弹出框样式 */
#illegalReport .el-dialog {
  min-width: 840px;
}
#illegalReport .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
#illegalReport .el-dialog__title {
  color: white;
}
#illegalReport .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
#illegalReport .el-dialog__body {
  padding: 3px 10px;
  font-size: 13px;
  /* font-family: "宋体"; */
}
#illegalReport .fRemark > .el-textarea__inner {
  height: 100px;
}
#illegalReport .fRemark_row .el-form-item__content {
  height: 100px;
}
/* 文本框样式 */
#illegalReport .el-input__inner {
  height: 32px;
  line-height: 32px;
}
#illegalReport .el-input.is-disabled .el-input__inner,
#illegalReport .el-textarea.is-disabled .el-textarea__inner {
  color: #606266;
}
#illegalReport .break_rule_img .el-form-item__content {
  height: 300px;
}
</style>
<style scoped>
.el-form-item {
  margin-bottom: 5px;
}
.pagination {
  text-align: right;
  padding-top: 5px;
}
.search {
  width: 200px;
}
.danger {
  color: #f56c6c;
}
.success {
  color: #67c23a;
}
</style>



// WEBPACK FOOTER //
// src/view/report/illegalReport.vue